/**
 * User Service – real API only.
 * User list and CRUD: getUsers, getUsersByOrganizationPaginated, getUsersByOrganization (for wizard), updateUserApi.
 */

import { apiClient } from './apiClient';
import * as realUserService from './real/userService.real';

/**
 * Get list of all users (real API). Used by User Management.
 */
export const getUsers = async () => {
  const response = await apiClient.get('/api/web-api/users/');
  return response.data;
};

/**
 * Update user by ID (real API PATCH). Used by User Management.
 */
export const updateUserApi = async (id, userData) => {
  const response = await apiClient.patch(`/api/web-api/users/${id}/`, userData);
  return response.data;
};

/**
 * Get users for an organization with pagination (for "Load more" list).
 * GET /api/v3/users?page=&page_size=
 */
export const getUsersByOrganizationPaginated = async (organizationId, params = {}) => {
  return realUserService.getUsersByOrganizationPaginated(organizationId, params);
};

const USERS_PAGE_SIZE = 50;

/**
 * Get all users for an organization (full list). Used by onboarding getWizardStatus.
 * Fetches pages until no more; use getUsersByOrganizationPaginated for UI lists.
 */
export const getUsersByOrganization = async (organizationId) => {
  const all = [];
  let cursor = null;
  let hasMore = true;
  while (hasMore) {
    const result = await realUserService.getUsersByOrganizationPaginated(organizationId, {
      limit: USERS_PAGE_SIZE,
      cursor: cursor ?? 1,
    });
    const data = result?.data ?? [];
    all.push(...data);
    hasMore = result?.pagination?.nextCursor != null && data.length >= USERS_PAGE_SIZE;
    cursor = result?.pagination?.nextCursor ?? null;
  }
  return all;
};

// Re-export shared validators for backward compatibility
export { isValidEmail, isValidPhoneNumber } from '../utils/serviceValidators';
